import apiClient from '@/lib/api-client';

export interface CandidateRule {
  _id: string;
  patternKey: string;
  status: 'candidate' | 'active' | 'promoted' | 'degraded' | 'disabled';
  layer: number;
  fieldName: string;
  transformationType: 'formatting' | 'mapping';
  exampleFromValue: string;
  exampleToValue: string;
  confirmationCount: number;
  uniqueEmployeeCount: number;
  totalObservations: number;
  confidence: number;
  acceptCount: number;
  rejectCount: number;
  acceptanceRate: number;
  autoCorrectionEnabled: boolean;
  firstDetectedAt: string;
  lastDetectedAt: string;
  promotedAt: string | null;
  degradedAt: string | null;
  disabledAt: string | null;
  degradedReason: string | null;
  disabledReason: string | null;
  overrideHistory?: Array<{
    reason: string;
    userId?: number;
    timestamp: string;
  }>;
}

export async function getCompiledRules(): Promise<{ data: CandidateRule[] }> {
  const response = await apiClient.get<{ data: { items: CandidateRule[] } }>(
    '/dqs/rules/compiled',
  );
  return { data: response.data.data?.items || [] };
}

export async function getRuleDetail(ruleId: string): Promise<{ data: CandidateRule }> {
  const response = await apiClient.get<{ data: CandidateRule }>(
    `/dqs/rules/${ruleId}`,
  );
  return response.data;
}

export async function toggleAutoCorrection(
  ruleId: string,
  enabled: boolean,
): Promise<void> {
  await apiClient.put(`/dqs/rules/${ruleId}/auto-correction`, { enabled });
}
